<template>
  <span class="text-nowrap">
    <svg-icon icon="calendar" />
    <span v-if="end">{{ startDate }} - {{ endDate }}</span>
    <span v-else>{{ startDate }}</span>
  </span>
</template>

<script>
import { toUTCDate } from '../utils/date';

export default {
  props: {
    start: {
      type: String,
      required: true
    },
    end: {
      type: String,
      required: true
    }
  },

  computed: {
    startDate() {
      return this.$filters.formatDate(toUTCDate(this.start));
    },

    endDate() {
      return this.$filters.formatDate(toUTCDate(this.end));
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  color: $light;
  font-size: 14px;
  display: flex;
  align-items: center;

  span,
  i {
    display: inline-block;
    vertical-align: middle;
  }

  i {
    position: relative;
    top: -1px;
    margin-right: 0.25rem;
  }
}
</style>
